var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 14.5833C17.875 15.1359 17.6336 15.6658 17.2038 16.0565C16.774 16.4472 16.1911 16.6667 15.5833 16.6667C14.9755 16.6667 14.3927 16.4472 13.9629 16.0565C13.5331 15.6658 13.2917 15.1359 13.2917 14.5833C13.2917 14.0308 13.5331 13.5009 13.9629 13.1102C14.3927 12.7195 14.9755 12.5 15.5833 12.5C16.1911 12.5 16.774 12.7195 17.2038 13.1102C17.6336 13.5009 17.875 14.0308 17.875 14.5833ZM8.70833 14.5833C8.70833 15.1359 8.46689 15.6658 8.03712 16.0565C7.60735 16.4472 7.02445 16.6667 6.41667 16.6667C5.80888 16.6667 5.22598 16.4472 4.79621 16.0565C4.36644 15.6658 4.125 15.1359 4.125 14.5833C4.125 14.0308 4.36644 13.5009 4.79621 13.1102C5.22598 12.7195 5.80888 12.5 6.41667 12.5C7.02445 12.5 7.60735 12.7195 8.03712 13.1102C8.46689 13.5009 8.70833 14.0308 8.70833 14.5833Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2913 14.583H8.70801M13.7497 12.9163V5.83301C13.7497 4.65467 13.7497 4.06551 13.3463 3.69967C12.9448 3.33301 12.2968 3.33301 10.9997 3.33301H4.58301C3.28684 3.33301 2.63876 3.33301 2.23634 3.69967C1.83301 4.06467 1.83301 4.65384 1.83301 5.83301V12.4997C1.83301 13.2788 1.83301 13.668 2.01726 13.958C2.13793 14.148 2.3115 14.3058 2.52051 14.4155C2.83951 14.583 3.26759 14.583 4.12467 14.583M14.208 5.41634H15.8589C16.6198 5.41634 17.0002 5.41634 17.3155 5.57884C17.6308 5.74051 17.8261 6.03717 18.2175 6.63051L19.7749 8.98884C19.9693 9.28384 20.0664 9.43217 20.1168 9.59551C20.1663 9.75967 20.1663 9.93134 20.1663 10.2755V12.4997C20.1663 13.2788 20.1663 13.668 19.9821 13.958C19.8614 14.148 19.6879 14.3058 19.4788 14.4155C19.1598 14.583 18.7318 14.583 17.8747 14.583",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70833 7.15858L6.68667 5.79642C7.20833 5.07133 7.46833 4.70833 7.79167 4.70833M7.79167 4.70833C8.115 4.70833 8.375 5.07133 8.89667 5.79642L9.875 7.15858M7.79167 4.70833L7.79167 11.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickUp);
export default __webpack_public_path__ + "static/media/pickUp.ba90e2db631602b45f7450fc0d44f25c.svg";
export { ForwardRef as ReactComponent };